module.exports = __webpack_public_path__ + "static/media/headbrain.3e3e067a.svg";